/**
 * @fileoverview O fim da esteira de cadastro: o resumo do que foi feito (a
 * Empresa, a conta, a IA ligada, o WhatsApp conectado e a equipe convidada) e o
 * que ficou para depois, que aparece no checklist do painel. As linhas entram
 * uma depois da outra, uma vez (com o movimento reduzido, já aparecem).
 */

import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Check } from "lucide-react";

import { useAuthFormStyles } from "../AuthLayout/formStyles";
import { PAID_PLAN_NAMES } from "../../utils/billingPlans";
import { i18n } from "../../translate/i18n";
import useSetupStyles from "./styles";

const t = (key, options) => i18n.t(`companySetup.${key}`, options);
const ROW_DELAY_MS = 70;

const teamText = (count, ready) => {
  if (count > 1) return t("done.teamMany", { count });
  if (count === 1) return t("done.teamOne");
  // Sem convite pendente e com outra pessoa na conta: o convite já foi aceito.
  return ready ? t("done.teamJoined") : t("done.teamNone");
};

const DoneStep = ({ setup, invitesSent, finishing, onFinish }) => {
  const form = useAuthFormStyles();
  const classes = useSetupStyles();
  const ready = setup.readiness || {};
  const rows = [
    { key: "company", value: setup.company?.name, done: true },
    { key: "account", value: setup.account?.name, done: true },
    { key: "ai", value: ready.ai ? t("done.aiOn") : t("done.aiOff"), done: !!ready.ai },
    { key: "whatsapp", value: ready.whatsapp ? t("done.whatsappOn") : t("done.whatsappOff"), done: !!ready.whatsapp },
    { key: "team", value: teamText(invitesSent, !!ready.team), done: !!ready.team || invitesSent > 0 },
  ];

  return (
    <div className={`${classes.step} ${form.view}`}>
      <h1 className={form.title}>{t("done.title")}</h1>
      <p className={form.subtitle}>{t("done.subtitle")}</p>
      <dl className={classes.summary}>
        {rows.map((row, position) => (
          <div key={row.key} className={classes.summaryRow} style={{ animationDelay: `${position * ROW_DELAY_MS}ms` }}>
            <span className={`${classes.summaryMark}${row.done ? ` ${classes.summaryMarkDone}` : ""}`} aria-hidden="true">
              {row.done && <Check size={12} strokeWidth={3} />}
            </span>
            <dt className={classes.summaryLabel}>{t(`steps.${row.key}`)}</dt>
            <dd className={`${classes.summaryValue}${row.done ? "" : ` ${classes.summaryPending}`}`}>{row.value}</dd>
          </div>
        ))}
      </dl>
      <div className={classes.actions}>
        <button type="button" className={`${form.button} ${classes.actionButton}`} onClick={onFinish} disabled={finishing}>
          {finishing && <CircularProgress size={16} className={form.spinner} />}
          {setup.contractPlan ? t("done.submitContract", { plan: PAID_PLAN_NAMES[setup.contractPlan] }) : t("done.submit")}
        </button>
      </div>
    </div>
  );
};

export default DoneStep;
